import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import IrregularitiesIcon from 'assets/svgs/irregularitiesBlue.svg';
import { Link } from 'react-router-dom';
import { PermissionsService } from 'shared/services';
import { TestDayWarningModal } from 'shared/components';
import PlusIcon from 'assets/svgs/plusIcon24.svg';

import './TcEventIrregularities.scss';

const filterReviewed = (irregularities) =>
  irregularities.length && irregularities.filter((irreg) => irreg.reviewCompleteFlag).length;
const filterSubmitted = (irregularities) =>
  irregularities.length && irregularities.filter((irreg) => !irreg.reviewCompleteFlag).length;

const TcEventIrregularities = ({
  irregularities,
  tcEvent,
  onAdd,
  roomId,
  onCloseWarningModal,
  warningTestDayOpen,
  roomStatus,
}) => {
  const { t } = useTranslation();
  return (
    <section className="tc-event-irreg-section">
      <p className="mb-1">
        <span className="text-strong">{t('irregularities.submittedLabel')}: </span>
        {roomStatus ? roomStatus.submittedIrregularityCount || 0 : filterSubmitted(irregularities)}
      </p>
      <p className="mb-1">
        <span className="text-strong">{t('irregularities.reviewedLabel')}: </span>
        {roomStatus ? roomStatus.reviewedIrregularityCount || 0 : filterReviewed(irregularities)}
      </p>
      <div className="buttons-container">
        {onAdd && (
          <button className="btn btn-outline btn-small icon-link" onClick={onAdd}>
            <PlusIcon />
            <span>{t('irregularities.addIrregularityLabel')}</span>
          </button>
        )}
        {(onAdd ||
          PermissionsService.hasTestCenterManage(tcEvent.testCenterCycleId) ||
          PermissionsService.hasEventManage(tcEvent.id)) && (
          <Link
            to={`/irregularities/all/${tcEvent.id}${roomId ? `/${roomId}` : ''}`}
            className="btn-link icon-link">
            <IrregularitiesIcon />
            <span>{t('irregularities.manageIrregularitiesLabel')}</span>
          </Link>
        )}
      </div>

      {onAdd && (
        <TestDayWarningModal
          warningModalOpen={warningTestDayOpen}
          onSubmit={onAdd}
          closeWarningModal={onCloseWarningModal}
          message="irregularities.testDayWarning"
          startLabel="irregularities.logIrregularityLabel"
        />
      )}
    </section>
  );
};

export default TcEventIrregularities;

TcEventIrregularities.propTypes = {
  irregularities: PropTypes.arrayOf(
    PropTypes.shape({
      reviewCompleteFlag: PropTypes.bool,
    })
  ).isRequired,
  tcEvent: PropTypes.shape({
    id: PropTypes.number,
    testCenterCycleId: PropTypes.number,
  }).isRequired,
  roomStatus: PropTypes.shape({
    submittedIrregularityCount: PropTypes.number,
    reviewedIrregularityCount: PropTypes.number,
  }),
  onCloseWarningModal: PropTypes.func,
  warningTestDayOpen: PropTypes.bool,
  roomId: PropTypes.number,
  onAdd: PropTypes.func,
};
